import di from 'di'

import defaultConfig from 'app/config/config.default';
import developmentConfig from 'app/config/config.development';
import stagingConfig from 'app/config/config.staging';
import productionConfig from 'app/config/config.production';

import Authentication from '@wittignl/js-core/plugins/Authentication'
import EmailAccountType from 'app/auth/EmailAccountType'
import RelayAccountType from 'app/auth/RelayAccountType'
import AppSwitcherService from "app/services/AppSwitcherService";

export default class {

    run(){

        /* CONFIG */
        var config = defaultConfig;
        var envConfig = {};

        if(ENV == 'development'){
            envConfig = developmentConfig;
        }
        else if(ENV == 'staging'){
            envConfig = stagingConfig;
        }
        else if(ENV == 'production'){
            envConfig = productionConfig;
        }

        Object.assign(config, envConfig);
        di.set('config', config);


        /* AUTH */
        di.factory('auth', () => {

            const authManager = new Authentication();
            authManager.setSessionKey('session-admin');
            authManager.registerAccountType(EmailAccountType.NAME, new EmailAccountType);
            authManager.registerAccountType(RelayAccountType.NAME, new RelayAccountType);

            authManager.restoreSession();

            return authManager;
        });


        /* APP SWITCHER */
        di.factory('appSwitcher', () => new AppSwitcherService());
    }
}
